import { createAsyncThunk } from "@reduxjs/toolkit";
import { R_getUserInfo } from "api/user/userService";
import { updateJoyrideStatus, resetJoyrideTour, getJoyrideStatus } from "api/joyride";
import { JoyrideTourKey } from "api/joyride/types";

export const T_getUserInfo = createAsyncThunk('user/getInfo', async (_, thunkAPI) => {
    const res = await R_getUserInfo()
    return res
});

export const T_getJoyrideStatus = createAsyncThunk('user/getJoyrideStatus', async (_, thunkAPI) => {
    const res = await getJoyrideStatus();
    return res;
});

export const T_updateJoyrideStatus = createAsyncThunk(
    'user/updateJoyrideStatus',
    async (payload: { tourKey: JoyrideTourKey; completed: boolean }, thunkAPI) => {
        const res = await updateJoyrideStatus(payload.tourKey, payload.completed);
        return res;
    }
);

export const T_resetJoyrideTour = createAsyncThunk(
    'user/resetJoyrideTour',
    async (tourKey: JoyrideTourKey, thunkAPI) => {
        const res = await resetJoyrideTour(tourKey);
        return res;
    }
);